// extracted by mini-css-extract-plugin
var _1 = "CurrencyDetailsStyles-module__available_staked_eth___kDspL";
var _2 = "CurrencyDetailsStyles-module__available_staked_eth___kDspL";
var _3 = "CurrencyDetailsStyles-module__badge___QV17l";
var _4 = "CurrencyDetailsStyles-module__currencyName___keDSC";
var _5 = "CurrencyDetailsStyles-module__deposited_eth___D9Pgh";
var _6 = "CurrencyDetailsStyles-module__deposited_eth___D9Pgh";
var _7 = "CurrencyDetailsStyles-module__pending_staked_eth___Tyhva";
var _8 = "CurrencyDetailsStyles-module__pending_staked_eth___Tyhva";
var _9 = "CurrencyDetailsStyles-module__rewards_eth___IZu6C";
var _a = "CurrencyDetailsStyles-module__rewards_eth___IZu6C";
var _b = "CurrencyDetailsStyles-module__timelocked_staked_eth___WCe1V";
var _c = "CurrencyDetailsStyles-module__timelocked_staked_eth___WCe1V";
export { _1 as "availableStakedEth", _2 as "available_staked_eth", _3 as "badge", _4 as "currencyName", _5 as "depositedEth", _6 as "deposited_eth", _7 as "pendingStakedEth", _8 as "pending_staked_eth", _9 as "rewardsEth", _a as "rewards_eth", _b as "timelockedStakedEth", _c as "timelocked_staked_eth" }
